import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import wifichannels from '../../../data/wifichannels.json';

const convertFrequencyToKeyString = (frequency) => {
  var keyString = undefined;
  
  switch(frequency) {
    case "2.4":
      keyString = 'Twenty_Four_Ghz';
      break;
    case "5":
      keyString = 'Five_Ghz';
      break;
    default:
      console.log('Unhandled frequency while loading Wifi Channels');
      break;
  }

  return keyString;
};

const StatusWiFiChannelSelect = (props) => {

  const [wifiChannel, setStatusWiFiChannel] = useState(props.wifiChannel);

  const handleStatusWiFiChannelChanged = (event) => {
    setStatusWiFiChannel(event.target.value);
    if (props.onChange) {
      props.onChange({"wifiChannel": event.target.value});
    } else {
      console.error("StatusWiFiChannel changed handler not defined");
    }
  };

  useEffect(() => {
    setStatusWiFiChannel(props.wifiChannel);
  }, [props.wifiChannel]);

  const notEnoughData = 
    props.wifiRegion === null || 
    props.wifiRegion === undefined || 
    props.wifiFrequency === null || 
    props.wifiFrequency === undefined;

  const channelOptions = !notEnoughData ? 
    Object.entries(wifichannels).filter(([key, value]) => {
      return key === props.wifiRegion;
    }).flatMap(([key, value]) => {
      return value[convertFrequencyToKeyString(props.wifiFrequency)];
    }) 
    : [];  

  return (
    <TextField 
      select
      onChange={handleStatusWiFiChannelChanged}
      disabled={props.disabled}
      value={wifiChannel ?? '0'}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      <MenuItem key={"0"} value={'0'}>
        Auto
      </MenuItem>
      {channelOptions?.sort((t1, t2) => {
        return t1.channel < t2.channel ? -1 : 1;
      }).map(op => {
        return <MenuItem key={op.name} value={op.name}>{op.channel}</MenuItem>;
      })}
    </TextField>
  );
};

export default StatusWiFiChannelSelect;